import { getMinutesAndSeconds as goodGetMinutesAndSeconds } from '@hotjar/insights-common/lib/getMinutesAndSeconds';

/**
 * @deprecated import from @hotjar/insights-common/lib/getMinutesAndSeconds instead
 */
export const getMinutesAndSeconds = (totalMilliseconds?: number): string =>
  goodGetMinutesAndSeconds(totalMilliseconds);
